import { apiClient, USE_MOCK } from "./apiClient";
import mockDb from "./mockDb";

export const AvailabilityService = {
  getMyAvailability: async (date) => {
    // Need to know current employee ID. In real app, token handles it.
    // For mock, we'll try to get it from localStorage or context if possible, 
    // but here we might need to pass it or decode it. 
    // SIMPLIFICATION: We assume we store "currentUser" in localStorage for mock access, 
    // or we just look up the user in auth context. 
    
    // In a real API call: GET /availability?date=... (backend uses token)
    
    if (USE_MOCK) {
        // HACK: decode token or use stored user.
        // For simplicity, let's assume the UI passes employeeId if needed, OR we trust the mock to know "me".
        // But since service layer is stateless usually, let's look for a helper.
        // Actually, let's assume the caller passes employeeId for getEmployeeAvailability
        // But for "getMyAvailability", we need `me`.
        // Let's rely on the caller passing employeeId for now to Start Simple.
        console.warn("Mock: getMyAvailability reqs employeeId arg which is not standard but needed for stateless mock.");
        return []; 
    }
    const { data } = await apiClient.get(`/availability/me?date=${date}`);
    return data;
  },

  // Helper for direct usage where we know the ID (Admin or Self)
  getAvailability: async (employeeId, date) => {
    if (USE_MOCK) return mockDb.getAvailability(employeeId, date);
    const { data } = await apiClient.get(`/availability/${employeeId}?date=${date}`);
    return data;
  },

  saveAvailability: async (payload) => {
    // payload: { employeeId, date, slots, isActive }
    if (USE_MOCK) return mockDb.saveAvailability(payload);
    const { data } = await apiClient.post("/availability", payload);
    return data;
  }
};
